export default __webpack_public_path__ + "static/130-2ed0b21fd2c754b78000ded3eef7235a.jpg";